<template lang="pug">
  span(v-if="!isValid") —
  span(v-else-if="fancyDate")
    small.text-muted {{ formattedDate }}
    = ' '
    span {{ formattedTime }}
    = ' '
    small.text-muted {{ timezoneOffset }}
  span(v-else) {{ formattedTime }}
</template>

<script>
import {
  formatInstant,
  formatTimezoneOffset,
  parseEpochInstant,
  parseInstant
} from "../../lib/datetime";

export default {
  name: 'datetime',
  
  props: {
    dt: {
      type: [Number, String],
      default: null,
      required: true
    },
    tz: {
      type: String,
      default: 'UTC'
    },
    format: {
      type: String,
      default: 'HH:mm:ss.SS'
    },
    fancyDate: {
      type: Boolean,
      default: false
    },
    milliseconds: {
      type: Number,
      default: 1000,
      validator: (value) => [1, 1000].includes(value)
    }
  },
  
  computed: {
    isValid() {
      return this.instant != null;
    },

    instant() {
      if (typeof this.dt === 'number') {
        return parseEpochInstant(this.dt, this.milliseconds === 1000 ? 'seconds' : 'milliseconds');
      }

      if (typeof this.dt === 'string') {
        return parseInstant(this.dt, this.tz);
      }

      return null;
    },
    
    formattedDate() {
      return formatInstant(this.instant, this.tz, 'YYYY-MM-DD');
    },
    
    formattedTime() {
      return formatInstant(this.instant, this.tz, this.format);
    },
    
    timezoneOffset() {
      return formatTimezoneOffset(this.instant, this.tz);
    }
  }
};
</script>
